<app-site-widget
  title="Hourly Idle Times"
  tooltipText="Displays the average time (in minutes) that batteries remain idle per hour of the day. Helps identify operational patterns and potential downtime opportunities."
  elementId="idle_times"
  chartType="line"
  widgetClass="height-100"
  [siteWidgetOptions]="{
    hasDate: true,
    isSitePerformanceWidget: true,
    hasAverageTimesPerBattview: true,
    isMaterialChart: false
  }"
  [widgetOptions]="{ hasExport: false, showTagFilter: false }"
  [data]="data"
  [hideTable]="true"
  [hideDevs]="true"
  (eventEmit)="eventEmit($event)"
  [config]="config"
  [tableColumns]="tableColumns"
  [customerName]="customerName"
  [siteName]="siteName"
  [siteId]="siteId"
></app-site-widget>
